@if (state && state.roleOptions.length && !state.isLoading && !state.hasLoadError) {
    <lib-generic-dropdown-multiselect
        [source]="state.roleOptions"
        [selectedItems]="state.selectedRoles"
        (selectedItemsChange)="onSelectedRolesChange($event)"
        [config]="state.dropdownConfig"
        ariaLabel="Company Roles"
        placeholder="Select Company Roles"
        [error]="state.showValidationError"
    >
    </lib-generic-dropdown-multiselect>
}
